import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  DatePicker,
  Button,
  Select,
  Table,
  InputNumber,
  Popconfirm,
  message,
  Card,
  Upload,
  notification,
} from "antd";
import RequestHandler from "../../util/RequestHandler";
import { odata } from "../Filters/Helper";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { use } from "react";

const OrderDeliveryAddForm = (props) => {
  const [form] = Form.useForm();
  const [orderSelect, setOrderSelect] = useState({
    data: [],
    loading: false,
  });
  const [orderItems, setOrderItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get("mode") || "edit"; // default edit
  const isViewMode = mode === "view";

  useEffect(() => {
    if (props && props.orderId) {
      form.setFieldsValue({ orderId: props.orderId });
      getOrderData(props.orderId);
    }
  }, []);

  const handleOrderChange = (orderId) => {
    const selectedOrder = orderSelect.data.find((o) => o.id === orderId);
    if (selectedOrder) {
      if (props.isDefaultAdd) {
        RequestHandler.get(`/Order/GetById/${orderId}`).then((response) => {
          if (response) {
            const data = response;

            form.setFieldsValue({
              orderId: data.id,
            });
            setOrderItems(
              data.orderItems.map((item) => ({
                key: item.id,
                id: item.id,
                stockId: item.stockId,
                name: item.name,
                stockCode: item.stockCode,
                orderQuantity: item.quantity,
                deliveryQuantity: null,
              }))
            );
          }
        });
      } else {
        setOrderItems(
          selectedOrder?.orderItems?.map((item) => ({
            key: item.id,
            id: item.id,
            stockId: item.stockId,
            name: item.name,
            stockCode: item.stockCode,
            orderQuantity: item.quantity,
            deliveryQuantity: null,
          }))
        );
      }
    } else {
      setOrderItems([]);
    }
  };

  const handleDelete = (key) => {
    setOrderItems((prev) => prev.filter((item) => item.key !== key));
  };

  const columns = [
    {
      title: "Malzeme Adı",
      dataIndex: "name",
      key: "name",
      align: "center",
    },
    {
      title: "Malzeme Kodu",
      dataIndex: "stockCode",
      key: "stockCode",
      align: "center",
    },
    {
      title: "Sipariş Miktarı",
      dataIndex: "orderQuantity",
      key: "orderQuantity",
      align: "center",
    },
    {
      title: "Teslimat Miktarı",
      dataIndex: "deliveryQuantity",
      key: "deliveryQuantity",
      align: "center",
      width: "25%",
      render: (_, record) => (
        <InputNumber
          className="ant-input"
          style={{ width: "100%" }}
          decimalSeparator=","
          thousandSeparator="."
          precision={0}
          min={0}
          max={record.orderQuantity}
          value={record.deliveryQuantity}
          onChange={(val) => {
            setOrderItems((prev) =>
              prev.map((item) =>
                item.key === record.key
                  ? { ...item, deliveryQuantity: val }
                  : item
              )
            );
          }}
        />
      ),
    },
    {
      title: "Sil",
      key: "action",
      width: 60,
      render: (_, record) => (
        <Button
          danger
          type="link"
          icon={<DeleteOutlined />}
          onClick={() => handleDelete(record.key)}
        ></Button>
      ),
    },
  ];

  const onFinish = async () => {
    setLoading(true);
    if (files.length === 0) {
      setLoading(false);
      notification.error({
        message: "Teslimat dosyası eksik.",
        description: "Lütfen teslimat dosyalarını ekleyiniz.",
        placement: "topRight",
      });
      return; // Hatalıysa devam etme
    }
    const values = await form.validateFields();
    const payload = {
      deliveryNumber: values.deliveryNumber,
      deliveryDate: values.deliveryDate
        ? values.deliveryDate.format("YYYY-MM-DD")
        : null,
      description: values.description,
      orderId: values.orderId,
      orderDeliveryItemAddDtos: orderItems
        .filter((i) => i.deliveryQuantity !== null && i.deliveryQuantity > 0)
        .map((i) => ({
          quantity: i.deliveryQuantity,
          stockId: i.stockId,
          orderDeliveryId: values.orderId,
        })),
    };
    const formData = new FormData();
    formData.append("jsonString", JSON.stringify(payload));
    // Files alanı: her dosyayı ayrı ayrı 'Files' olarak append et
    files.forEach((file) => {
      formData.append("files", file.originFileObj);
    });

    RequestHandler.post(
      `/OrderDelivery`,
      formData,
      true,
      {},
      "multipart/form-data"
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        props.onSuccess();
      }
    });
    setLoading(false);
  };

  const getOrderData = (orderId) => {
    RequestHandler.get(`/Order/GetById/${orderId}`).then((response) => {
      if (response) {
        const data = response;
        //#region

        form.setFieldsValue({
          orderId: data.id,
        });
        setOrderItems(
          data.orderItems.map((item) => ({
            key: item.id,
            id: item.id,
            stockId: item.stockId,
            name: item.name,
            stockCode: item.stockCode,
            orderQuantity: item.quantity,
            deliveryQuantity: null,
          }))
        );

        setOrderSelect({ data: [data], loading: false });
      } else {
        message.error("Sipariş verileri alınamadı.");
      }
    });
  };

  const onOrderSearch = (value) => {
    if (value.length >= 2) {
      setOrderSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Order/GetListForDelivery?$select=id,name,description,orderStatus&$filter=orderStatus ne 'Completed' and ${odata.contains(
          "name",
          value
        )}`
      ).then((res) => {
        setOrderSelect({ data: res, loading: false });
      });
    } else {
      setOrderSelect({ data: [], loading: false });
    }
  };

  useEffect(() => {
    RequestHandler.get(
      `/Order/GetListForDelivery?$select=id,name,description,orderStatus&$filter=orderStatus ne 'Completed'`
    ).then((res) => {
      if (res) {
        setOrderSelect({ data: res, loading: false });
      } else {
        setOrderSelect({ data: [], loading: false });
      }
    });
  }, []);

  return (
    <Form layout="vertical" form={form}>
      <Form.Item label="Sipariş :" name="orderId">
        <Select
          allowClear
          showSearch
          onSearch={onOrderSearch}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
            option.code
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
          loading={orderSelect.loading}
          disabled={props && props.orderId} // Disable if orderId is passed as prop
          onChange={handleOrderChange}
        >
          {orderSelect.data.map((item) => (
            <Select.Option
              key={item.id}
              value={item.id}
              description={item.description}
            >
              {item.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label="İrsaliye Numarası :"
        name="deliveryNumber"
        rules={[{ required: true, message: "İrsaliye numarası gerekli" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item label="Teslimat Tarihi :" name="deliveryDate">
        <DatePicker format="YYYY-MM-DD" style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item label="Açıklama :" name="description">
        <Input.TextArea rows={3} />
      </Form.Item>
      <Card
        title={
          <span style={{ fontWeight: "bold", fontSize: 18 }}>Dosyalar</span>
        }
        bordered={false}
        style={{ marginTop: 16 }}
      >
        {/* Yeni dosya yükleme alanı */}
        <Upload
          multiple
          beforeUpload={() => false}
          onChange={({ fileList }) => setFiles(fileList)}
          fileList={files}
        >
          <Button icon={<UploadOutlined />} disabled={isViewMode}>
            Dosya Yükle
          </Button>
        </Upload>
      </Card>

      <Table
        dataSource={orderItems}
        columns={columns}
        pagination={false}
        rowKey="key"
        style={{ marginTop: 16 }}
        scroll={{ x: true }}
      />

      <div style={{ marginTop: 16, textAlign: "right" }}>
        <Button onClick={props.onCancel} style={{ marginRight: 8 }}>
          İptal
        </Button>
        <Button type="primary" onClick={onFinish} loading={loading}>
          Ekle
        </Button>
      </div>
    </Form>
  );
};

export default OrderDeliveryAddForm;
